import { Avatar, Box, Button, Container, FormLabel, Heading, Input, VStack } from '@chakra-ui/react'
import React,{useState} from 'react'
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { register } from '../../../redux/actions/user';

const Register = () => {
    const [email,setEmail]= useState();
    const [password,setPassword]=useState();
    const [name,setName]=useState();
    const [imgPrev,setImgPrev]=useState();
    const [img,setImg]=useState();
    const changeImgHandler=(e)=>{
        const file = e.target.files[0];
        const reader = new FileReader();

        reader.readAsDataURL(file);
        reader.onloadend=()=>{
            setImgPrev(reader.result);
            setImg(file);
        }
    }
    const dispatch=useDispatch();
    const submitHandler =(e)=>{
        e.preventDefault();
        const myForm = new FormData();

        myForm.append("name",name);
        myForm.append("email",email);
        myForm.append("password",password);
        myForm.append("file",img);

        dispatch(register(myForm));
    }
  return (
    <Container h={'95vh'}>
        <VStack h={'full'} justifyContent='center' spacing={'16'}>
            <Heading children={'Register Now'}/>
            <form onSubmit={submitHandler} style={{width:'100%'}}>
                <Box my={'2'} display={'flex'} justifyContent='center'>
                    <Avatar src={imgPrev} size={'2xl'}/>
                </Box>
                 <Box my={'2'}>
                <FormLabel htmlFor='name' children='Name'/>
                <Input required id='name' value={name} onChange={(e)=>setName(e.target.value)} placeholder='name' type='text' focusBorderColor='yellow.500' />
                </Box>
                <Box my={'2'}>
                <FormLabel htmlFor='email' children='Email Address'/>
                <Input required id='email' value={email} onChange={(e)=>setEmail(e.target.value)} placeholder='ok123@gmail.com' type='email' focusBorderColor='yellow.500' />
                </Box>
                <Box my={'2'}>
                <FormLabel htmlFor='password' children='Password'/>
                <Input required id='password' value={password} onChange={(e)=>setPassword(e.target.value)} placeholder='*******' type='password' focusBorderColor='yellow.500' />
                </Box>
                <Box my={'2'}>
                <FormLabel htmlFor='chooseAvatar' children='Choose Avatar'/>
                <Input accept='image/*' required id='chooseAvatar' type={'file'} focusBorderColor='yellow.500' 
                       css={{
                        "&::file-selector-button":{
                            cursor:"pointer",marginLeft:"-5%",
                            width:"110%",
                            border:"none",
                            height:"100%",
                            color:'#ECC94B',
                            backgroundColor:'white'
                        }
                       }}
                       onChange={changeImgHandler}
                />
                </Box>
               <Button my={'2'} colorScheme={'yellow'} type='Submit'>Sign up</Button>
                <Box my={'2'} >
                    Already a User?   <Link to="/login"><Button colorScheme={'yellow'} variant='link'>Login Now</Button></Link>
                </Box>
            </form>
        </VStack>
    </Container>
  )
}

export default Register